import { Component, Input } from '@angular/core';
import { ConstantHelper } from '@veritas-shared/helpers/constant.helper';
import { BaseLayoutOption } from '@veritas-shared/models/base-layout.model';

@Component({
  selector: 'app-base-layout',
  templateUrl: './base-layout.component.html',
  styleUrls: ['./base-layout.component.scss']
})
export class BaseLayoutComponent {
  @Input() options: BaseLayoutOption;

  constructor(
    public constantHelper: ConstantHelper
  ) {
    this.options = null;
  }
}
